module.exports = __webpack_public_path__ + "static/img/NjImg.d4c6f6cd.png";